export default {
  errorBoundaryHeader: 'Sorry…we’re experiencing a problem.',
  errorBoundarySubHeader: 'Please try again later.',
};
